module.exports = __webpack_public_path__ + "img/8.2ab6ddb1.jpg";